import { render, staticRenderFns } from "./CategoriesItems.vue?vue&type=template&id=9c434532&scoped=true&"
import script from "./CategoriesItems.vue?vue&type=script&lang=js&"
export * from "./CategoriesItems.vue?vue&type=script&lang=js&"
import style0 from "./CategoriesItems.vue?vue&type=style&index=0&id=9c434532&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c434532",
  null
  
)

export default component.exports